import React, { Component } from 'react'
import { Table, Skeleton, message } from 'antd'
import InfiniteScroll from 'react-infinite-scroller'

import AppContext from '../../../AppContext'
import ExpandMenuIcon from '../../../components/ui/general/icons/ExpandMenuIcon'
import PopoverButton from '../../../components/ui/general/buttons/PopoverButton'
import LoadingButton from '../../../components/ui/general/buttons/LoadingButton'
import CreateProductionModal from '../../../components/ui/dataEntry/other/CreateProductionModal'
import FixedTableHeader from '../../../components/ui/dataDisplay/FixedTableHeader'
import AdminItemConfirmModal from '../../../components/ui/feedback/AdminItemConfirmModal'
import { utilityService } from '../../../services/UtilityService'

import { graphql, withApollo } from '@apollo/client/react/hoc'
import _, { cloneDeep, flowRight as compose } from 'lodash'
import QueryProductionStudio from '../../../graphQL/admin/entertainmentData/listProduction'
import MutationDeleteProductionStudio from '../../../graphQL/admin/entertainmentData/deleteProductionStudio'
import FilterInput from '../../../components/ui/dataEntry/inputs/FilterInput'

const deleteProductionMessage = {
  title: 'DELETE PRODUCTION',
  firstMessage: 'Are you sure you want to delete this Production?',
  secondMessage: 'This action cannot be undone.'
}

const options = [
  {
    type: 'edit',
    name: 'Edit'
  }
]

class ProductionList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      openedCategory: null,
      isLoading: !(props.productionList && props.productionList.length),
      showAddProductionModal: false,
      showDeleteProductionModal: false,
      selectedProduction: undefined,
      deleteLoading: false,
      isDeleted: false,
      productionSearch: { searchString1: '', searchString2: '' }
    }
    this.columns = [
      {
        title: 'Production Studio',
        dataIndex: 'name',
        key: 'name',
        width: '37%',
        className: 'entertainment-data'
      },
      {
        title: 'Usage Count',
        dataIndex: 'assetCount',
        width: '50%',
        key: 'assetCount',
        render: (assetCount, { isError }) => this.renderAssetCount(assetCount, isError)
      },
      {
        key: 'id',
        dataIndex: 'id',
        width: '3%',
        render: (id) => this.renderData(id)
      }
    ]
  }

    componentDidMount = () => {
      document.addEventListener('mousedown', this.handleClickOutside)
    }

    UNSAFE_componentWillReceiveProps = newProps => { // eslint-disable-line camelcase
      if (!newProps.isLoading && !_.isEqual(newProps.productionList, this.props.productionList)) {
        this.setState({ isSearching: false, isPaginating: false, isLoading: false })
      } else if (!newProps.isLoading && this.props.isLoading && this.state.isSearching && _.isEqual(newProps.productionList, this.props.productionList)) {
        this.setState({ isSearching: false, isLoading: false })
      } else if (!newProps.isLoading && _.isEqual(newProps.productionList, this.props.productionList) && this.props.productionFilter && this.props.productionFilter.searchString) {
        this.setState({ isSearching: false, isLoading: false })
      } else if (!newProps.isLoading && _.isEmpty(newProps.productionList)) {
        this.setState({ isLoading: false })
      }
    }

    componentWillUnmount () {
      document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside = (event) => {
      const { target } = event
      const { className } = target
      const availableOptions = ['edit', 'delete']
      const isOptionClicked = availableOptions.findIndex(item => className === item)
      if (isOptionClicked > -1) {
        return
      }
      if (this.state.openedProduction) {
        this.setState({ openedProduction: null })
      }
    }

    toggleShowOptions = id => {
      if (this.state.openedProduction === id) {
        this.setState({ openedProduction: null })
      } else {
        this.setState({ openedProduction: id })
      }
    }

    onSelectOption = (id, selectedOption) => {
      const { productionList } = this.props
      const selectedProduction = productionList.find(item => item.id === id)
      if (!selectedProduction) {
        return
      }
      if (selectedOption.type === 'edit') {
        this.setState({ showAddProductionModal: true, selectedProduction })
      } else if (selectedOption.type === 'delete') {
        this.setState({ showDeleteProductionModal: true, selectedProduction })
      }
      this.setState({ openedProduction: null })
    }

    onProductionSelect = (selectedValue, field) => {
      if (field === 'to') {
        this.setState({ toSelectedProduction: selectedValue })
      } else {
        this.setState({ fromSelectedProduction: selectedValue })
      }
    }

    showAddProduction = () => {
      this.setState({ showAddProductionModal: true })
    }

    hideAddProductionModal = () => {
      this.setState({ showAddProductionModal: false, selectedProduction: null })
    }

    handleAddProduction = () => {
      this.setState({ showAddProductionModal: false, selectedProduction: null })
    }

    hideDeleteProductionModal = () => {
      this.setState({ isDeleted: true, selectedProduction: null }, () => {
        this.setState({ showDeleteProductionModal: false, isDeleted: false })
      })
    }

    handleDeleteProduction = () => {
      const { selectedProduction } = this.state
      const { onHistoryUpdate } = this.props
      if (!selectedProduction) {
        return
      }
      this.setState({ deleteLoading: true })
      this.props.deleteProductionStudio(selectedProduction.id, selectedProduction.name).then(() => {
        message.success('Production deleted successfully')
        this.setState({ isDeleted: true, selectedProduction: null }, () => {
          this.setState({ showDeleteProductionModal: false, deleteLoading: false, isDeleted: false })
        })
        onHistoryUpdate()
      }, error => {
        this.setState({ isDeleted: true, selectedProduction: null }, () => {
          this.setState({ showDeleteProductionModal: false, deleteLoading: false, isDeleted: false })
        })
        utilityService.handleError(error)
      })
    }

    onSearchOptions = (value, isFirst) => {
      let { productionSearch } = this.state
      if (isFirst) {
        productionSearch.searchString1 = value
      } else {
        productionSearch.searchString2 = value
      }
      this.setState({ productionSearch })
    }

    onChangeFilter = value => {
      this.setState({ isLoading: true, isSearching: true })
      this.props.onChangeProductionFilter({ searchString: value })
    }

    loadMoreAsset = () => {
      if (this.props.totalCount === this.props.productionList.length || this.state.isPaginating) { return }
      this.setState({ isPaginating: true }, () => this.props.getMoreProductions(this.props.productionList.length))
    }

    renderAssetCount = (count, isError) => {
      if (isError) {
        return <div>{'Error in Transfer. Retry'}</div>
      } else if (!count) {
        return '0'
      } else {
        return count
      }
    }

    renderData = (id) => {
      let availableOptions = _.cloneDeep(options)
      const { openedProduction } = this.state
      const { productionList } = this.props
      const selectedProduction = productionList.find(item => item.id === id)
      if (selectedProduction && (!selectedProduction.assetCount || !parseInt(selectedProduction.assetCount)) && !this.isDeleteDisabled) {
        const deleteOption = {
          type: 'delete',
          name: 'Delete'
        }
        availableOptions.push(deleteOption)
      }
      if (!selectedProduction.assetCount || !parseInt(selectedProduction.assetCount)) {
        // availableOptions.splice(1, 1)
        if (this.isUpdateDisabled) {
          availableOptions.splice(0, 1)
        }
      } else if (this.isUpdateDisabled) {
        availableOptions.splice(0, 1)
      }
      if (availableOptions && availableOptions.length) {
        return (
          <div className='option-list' id='option-list'>
            <PopoverButton
              button={<div onClick={(e) => this.toggleShowOptions(id)} > <ExpandMenuIcon /> </div>}
              displayParam='name'
              contents={availableOptions}
              onContentClick={(selectedOption) => this.onSelectOption(id, selectedOption)}
              parentCompoent={'option-list'}
              isVisible={openedProduction === id}
              placement={'leftBottom'}
            />
          </div>
        )
      } else {
        return null
      }
    }

    render () {
      const { productionList, productionFilter, onHistoryUpdate } = this.props
      const { isLoading, isPaginating, showAddProductionModal, showDeleteProductionModal, selectedProduction, deleteLoading, isDeleted } = this.state
      let adminItem
      if (selectedProduction && showDeleteProductionModal) {
        adminItem = <div >
          <p>{ selectedProduction.name }</p>
        </div>
      }
      return (
        <AppContext.Consumer>
          {({ permissions, project }) => {
            const userPermissions = permissions['DATA_MANAGER']
            const isCreateDisabled = userPermissions.indexOf('CREATE') === -1
            this.isDeleteDisabled = userPermissions.indexOf('DELETE') === -1
            this.isUpdateDisabled = userPermissions.indexOf('UPDATE') === -1
            return <div className='admin-portal entertainment-list'>
              <FilterInput
                searchString={productionFilter.searchString}
                onChangeSearchInput={this.onChangeFilter}
                placement='rightTop'
                project={project}
              />
              <div className='admin-list production-list'>
                <FixedTableHeader columnCellList={this.columns} />
                <InfiniteScroll
                  pageStart={0}
                  loadMore={this.loadMoreAsset}
                  hasMore={this.props.totalCount > productionList.length}
                  initialLoad={false}
                  useWindow={false}
                >
                  <Skeleton active avatar={false} title paragraph={{ rows: 6 }} loading={isLoading}>
                    <Table className={`general-table ${isPaginating ? 'paginating' : ''}`} rowKey={record => record.id} columns={this.columns} dataSource={productionList} pagination={false} />
                  </Skeleton>
                  <Skeleton active avatar={false} title paragraph={{ rows: 1 }} loading={isPaginating} />
                </InfiniteScroll>
              </div>
              <div className='admin-footer' >
                <LoadingButton
                  type='primary'
                  onClick={this.showAddProduction}
                  htmlType='submit'
                  buttonText={'New'}
                  buttonClass='save-btn'
                  isLoading={false}
                  isDisabled={isCreateDisabled}
                />
              </div>
              <CreateProductionModal
                isVisible={showAddProductionModal}
                handleCancel={this.hideAddProductionModal}
                handleSubmit={this.handleAddProduction}
                selectedProduction={selectedProduction}
                listApi module='DATA_MANAGER'
                isSubmitDisabled={_.isEmpty(selectedProduction) ? isCreateDisabled : this.isUpdateDisabled}
                onHistoryUpdate={onHistoryUpdate}
                isDeleted={isDeleted}
                searchString={productionFilter.searchString}
                project={project}
              />
              <AdminItemConfirmModal
                isVisible={showDeleteProductionModal}
                title={deleteProductionMessage.title}
                firstMessage={deleteProductionMessage.firstMessage}
                secondMessage={deleteProductionMessage.secondMessage}
                adminItem={adminItem}
                rightButtonText={'Delete'}
                handleCancel={this.hideDeleteProductionModal}
                handleSubmit={this.handleDeleteProduction}
                isSubmitButtonDisabled={this.isDeleteDisabled}
                isCancelButtonDisabled={false}
                isLoading={deleteLoading} />
            </div>
          }}
        </AppContext.Consumer>
      )
    }
}

ProductionList.propTypes = {}

export default withApollo(compose(
  graphql(
    QueryProductionStudio,
    {
      options: ({ productionFilter, project }) => {
        const { searchString } = productionFilter
        const search = searchString ? { keyword: searchString, fields: ['name'] } : null
        const variables = { search, offset: 0, limit: 20, project: project }
        return {
          fetchPolicy: 'network-only',
          variables
        }
      },
      props: (props) => {
        const { data } = props
        let productionList = data.listProductionStudio ? data.listProductionStudio.items : []
        productionList = productionList.map(item => {
          if (item.isTransferring) {
            item.assetCount = 'Transferring'
          }
          return item
        })
        return {
          productionList,
          isLoading: data.loading || !data.listProductionStudio,
          totalCount: data.listProductionStudio ? data.listProductionStudio.totalCount : 0,
          getMoreProductions: (page) => {
            return data.fetchMore({
              fetchPolicy: 'network-only',
              variables: {
                offset: page
              },
              updateQuery: (previous, { fetchMoreResult }) => {
                if (!fetchMoreResult) return previous
                const prev = cloneDeep(previous)
                const newList = [...prev.listProductionStudio.items, ...fetchMoreResult.listProductionStudio.items]
                prev.listProductionStudio.items = newList
                return prev
              }
            })
          }
        }
      }
    }
  ),
  graphql(
    MutationDeleteProductionStudio, {
      options: ({ productionFilter, project }) => ({
        update: (cache, { data: { deleteProductionStudio } }) => {
          const { searchString } = productionFilter
          const search = searchString ? { keyword: searchString, fields: ['name'] } : null
          const variables = { search, offset: 0, limit: 20, project }
          const cacheData = _.cloneDeep(cache.readQuery({ query: QueryProductionStudio, variables }))
          if (cacheData && cacheData.listProductionStudio && cacheData.listProductionStudio.items) {
            const selectedIndex = cacheData.listProductionStudio.items.findIndex(item => item.id === deleteProductionStudio.id)
            if (selectedIndex > -1) {
              cacheData.listProductionStudio.items.splice(selectedIndex, 1)
              cacheData.listProductionStudio.totalCount = cacheData.listProductionStudio.totalCount - 1
            }
          }
          cache.writeQuery({
            query: QueryProductionStudio,
            data: cacheData,
            variables
          })
        }
      }),
      props: (props) => ({
        deleteProductionStudio: (id, name) => {
          return props.mutate({
            variables: { id, name, project: props.ownProps.project }
          })
        }
      })
    }
  )
)(ProductionList))
